import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { colors } from '../../theme/colorTokens';

/**
 * "Tu siguiente paso" cross-link cards.
 * @param {{ title?: string, links: Array<{ label: string, to: string, external?: boolean }> }} props
 */
const CrossLinks = ({ title = 'También te puede interesar', links }) => {
  const { lng } = useParams();
  return (
    <Box sx={{ mt: { xs: 4, md: 5 }, mb: { xs: 2, md: 3 } }}>
      <Typography
        variant="h6"
        component="h3"
        sx={{ fontWeight: 600, fontSize: '16px', color: colors.textPrimary, mb: 2 }}
      >
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
        {links.map((link, i) =>
          link.external ? (
            <Paper
              key={i}
              component="a"
              href={link.to}
              target="_blank"
              rel="noopener noreferrer"
              elevation={0}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                px: 2,
                py: 1,
                borderRadius: '10px',
                border: `1px solid ${colors.border}`,
                fontSize: '13px',
                fontWeight: 500,
                color: colors.primary,
                textDecoration: 'none',
                transition: 'all 200ms ease',
                '&:hover': { borderColor: colors.primary, bgcolor: 'rgba(30,58,95,0.02)' },
              }}
            >
              {link.label}
              <ArrowForwardIcon sx={{ fontSize: 14 }} />
            </Paper>
          ) : (
            <Paper
              key={i}
              component={RouterLink}
              to={`/${lng}${link.to}`}
              elevation={0}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                px: 2,
                py: 1,
                borderRadius: '10px',
                border: `1px solid ${colors.border}`,
                fontSize: '13px',
                fontWeight: 500,
                color: colors.primary,
                textDecoration: 'none',
                transition: 'all 200ms ease',
                '&:hover': { borderColor: colors.primary, bgcolor: 'rgba(30,58,95,0.02)' },
              }}
            >
              {link.label}
              <ArrowForwardIcon sx={{ fontSize: 14 }} />
            </Paper>
          )
        )}
      </Box>
    </Box>
  );
};

export default CrossLinks;
